// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InventoryForm_field_header__Vh71Y {
    font-size: 1.0rem;
    font-weight: 600;
    margin-bottom: 7px;
    /* margin-top: 15px; */
    margin-top: 5px;
    word-wrap: normal;
    width: 75% !important;
    white-space: wrap;

    
}

.InventoryForm_buffer__8kbBB {
    margin-left: 0.5rem;
}

.InventoryForm_handle_overflow__rWZcQ {
    /* overflow-x: hidden; */
    text-overflow: ellipsis;
    /* white-space: nowrap;  */
    text-overflow: ellipsis;
    display: inline-block;
    overflow: hidden;
    width: 300px;
    white-space: nowrap;
    vertical-align: middle;
    
}

input {
    border: #b6b2b2 solid 1px;
    border-radius: 5px;
    width: 75%;
}

input.InventoryForm_err__0VnP3 {
    border-color: red !important;
}

.InventoryForm_switch__OoBNG.InventoryForm_err__0VnP3 {
    /* accent-color: red !important;
    appearance: none;
    margin-bottom: 0;
    width: 1em;
    height: 1em;
    background: red; */
    border-color: red !important;
}

.InventoryForm_inventory_container__E8BTS {
    margin: 30px 30px 10px 30px;
    /* margin-top: 2em;
    margin-bottom: 2em; */
    overflow-y: auto;
    overflow-x: auto;
    border: rgb(78, 77, 77) solid 1px;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
}



/* For confirmation dialog */
.InventoryForm_alert-title__chZHo {
    color: red;
    font-weight: bold;
    font-size: 1.3em;
}

.InventoryForm_alert-title-black__E0KgJ {
    color: black;
    font-weight: bold;
    font-size: 1.3em;
}

.InventoryForm_confirmation-text__uooMK {
    font-size: 1.4rem;
    list-style-type: none;
    padding: 0; /* Remove padding */
    margin: 0; /* Remove margins */
}



/* label .label-readonly {
    font-size: 0.5em;
} */

.InventoryForm_no-border__hhNmZ {
    border: 0 !important;
    box-shadow: none; /* You may want to include this as bootstrap applies these styles too */
    padding-bottom: 0 !important;
    text-overflow: ellipsis;
}

.InventoryForm_inventory_list_container__bqCB1 {
    /* margin: 30px 30px 30px 30px; */
    margin:0;
    /* margin-top: 2em;*/
    /* margin-bottom: 50px;  */
    overflow-y: auto;
    overflow-x: auto;
    /* border: rgb(246, 6, 6) solid 1px; */
    /* border: none; */
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 20px;
    padding-right: 20px;
    border: 1px solid gray;

}


.InventoryForm_inventory_list_container_border__eL0AI {
    /* border-bottom: 1px solid gray; */
    height: 10px;
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 20px;
    margin-bottom: 0;
}


.InventoryForm_relative__9x5wv {
    position: relative;
}

.InventoryForm_absolute__mpRH1 {
    position: absolute;
    width:100%;
    height:100%;
    top:0px;
    left: 0px;
    z-index: 2;
    /* border: none; */
    border-width: 1px;
    border-style: solid;
    /* gray;*/
}

.InventoryForm_absolute__mpRH1:hover {
    cursor:pointer;
    /* background-color: rgba(63, 85, 92, 0.1); */
    border-width: 5px;
    border-style: double;
    /* rgb(117, 116, 116); */
}

.InventoryForm_non-admin__S-0-n {
    border-color: gray;
}

.InventoryForm_attestation-unknown__Fyupc {
    border-color: gray;
}

.InventoryForm_uncertified__mYB\\+Z, .InventoryForm_not-attested__lUBMH {
    border-color: red;
}

.InventoryForm_uncertified-text__Ov9mi {
    color:red;
    font-weight: 600;
}


.InventoryForm_init-certified__-UHNO {
    border-color: orange;
}

.InventoryForm_init-certified-text__91XWl {
    color: orange;
    font-weight: 600;
}

.InventoryForm_final-certified__7mapw, .InventoryForm_attested__l0S6r {
    border-color: green;
}

.InventoryForm_final-certified-text__w4oZj {
    color: green;
    font-weight: 600;
}

.InventoryForm_attested-text__Ls4A7 {
    color: green;
    font-weight: 600;
}

.InventoryForm_not-attested-text__AIdyX {
    color: red;
    font-weight: 600;
}

.InventoryForm_cert-status__ZSL1- {
    width: 80% !important;
}

/* item-... - style to show certification status for admins */
.InventoryForm_item-uncertified__d9VoX, .InventoryForm_item-not-attested__2OEcY {
    background-color: red;
    color:white;
    font-weight: bold;
}


.InventoryForm_item-uncertified-text__2JEB9, .InventoryForm_item-not-attested-text__jXDEc {
    color: red;
    font-weight: 600;
}
/* .item-not-attested, .item-attested {
    text-align: center;
} */

.InventoryForm_item-init-certified__BmL9t {
    background-color: orange;
    color:white;
    font-weight: bold;
}

.InventoryForm_item-init-certified-text__4apA2 {
    color: orange;
    font-weight: 600;
}

.InventoryForm_item-final-certified__Njf3q, .InventoryForm_item-attested__BZNvq {
    background-color: green;
    color:white;
    font-weight: bold;
}

.InventoryForm_item-final-certified-text__iO\\+9C, .InventoryForm_item-attested-text__YcFqy {
    color: green;
    font-weight: 600;
}

.InventoryForm_readonly__0bEao:read-only {
    background-color: rgb(242, 242, 242);
    color:rgb(100, 100, 100);
}


/* .required {
    color: red;
    font-weight: normal;
}

.annotation {
    font-size: 0.8em;
} */

.InventoryForm_invalid-feedback-override__QIHwX {
    width: 75% !important;
    white-space: wrap;
    color: red;
    font-size: .875em;
}

.InventoryForm_form-field-info__oEJxY {
    width: 75% !important;
    white-space: wrap;
    color: rgb(0, 93, 192);
    font-size: .875em;
    font-style: italic;
}

.InventoryForm_textarea__S\\+-Rl {
    resize:both;
}

.InventoryForm_inline-block__ldHlS {
    display: inline-block;
}

input[type='checkbox']:enabled {
    border-color: rgb(39, 39, 39) !important;
}

.InventoryForm_sup__HbvCU {
    color: red;
    font-size: 0.9em;
}

.InventoryForm_ul-group-id__96HIV {
    color: red;
    /* font-size: 0.8em; */
    font-style: italic;
    font-weight: 600;
}

.InventoryForm_ul-no-bullets__Nqxg3
{
    list-style-type: none;
}

.InventoryForm_ul-no-bullets-li__6GJNH
{
    font-style: italic;
    font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/InventoryForm.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;;;AAGrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;;AAE1B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;;;;;sBAKkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;IAC3B;yBACqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;;;;AAIA,4BAA4B;AAC5B;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,UAAU,EAAE,mBAAmB;IAC/B,SAAS,EAAE,mBAAmB;AAClC;;;;AAIA;;GAEG;;AAEH;IACI,oBAAoB;IACpB,gBAAgB,EAAE,uEAAuE;IACzF,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;IACjC,QAAQ;IACR,oBAAoB;IACpB,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;;AAE1B;;;AAGA;IACI,mCAAmC;IACnC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,OAAO;IACP,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,6CAA6C;IAC7C,iBAAiB;IACjB,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;;AAGA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,6DAA6D;AAC7D;IACI,qBAAqB;IACrB,WAAW;IACX,iBAAiB;AACrB;;;AAGA;IACI,UAAU;IACV,gBAAgB;AACpB;AACA;;GAEG;;AAEH;IACI,wBAAwB;IACxB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,wBAAwB;AAC5B;;;AAGA;;;;;;;GAOG;;AAEH;IACI,qBAAqB;IACrB,iBAAiB;IACjB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".field_header {\n    font-size: 1.0rem;\n    font-weight: 600;\n    margin-bottom: 7px;\n    /* margin-top: 15px; */\n    margin-top: 5px;\n    word-wrap: normal;\n    width: 75% !important;\n    white-space: wrap;\n\n    \n}\n\n.buffer {\n    margin-left: 0.5rem;\n}\n\n.handle_overflow {\n    /* overflow-x: hidden; */\n    text-overflow: ellipsis;\n    /* white-space: nowrap;  */\n    text-overflow: ellipsis;\n    display: inline-block;\n    overflow: hidden;\n    width: 300px;\n    white-space: nowrap;\n    vertical-align: middle;\n    \n}\n\ninput {\n    border: #b6b2b2 solid 1px;\n    border-radius: 5px;\n    width: 75%;\n}\n\ninput.err {\n    border-color: red !important;\n}\n\n.switch.err {\n    /* accent-color: red !important;\n    appearance: none;\n    margin-bottom: 0;\n    width: 1em;\n    height: 1em;\n    background: red; */\n    border-color: red !important;\n}\n\n.inventory_container {\n    margin: 30px 30px 10px 30px;\n    /* margin-top: 2em;\n    margin-bottom: 2em; */\n    overflow-y: auto;\n    overflow-x: auto;\n    border: rgb(78, 77, 77) solid 1px;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n\n\n/* For confirmation dialog */\n.alert-title {\n    color: red;\n    font-weight: bold;\n    font-size: 1.3em;\n}\n\n.alert-title-black {\n    color: black;\n    font-weight: bold;\n    font-size: 1.3em;\n}\n\n.confirmation-text {\n    font-size: 1.4rem;\n    list-style-type: none;\n    padding: 0; /* Remove padding */\n    margin: 0; /* Remove margins */\n}\n\n\n\n/* label .label-readonly {\n    font-size: 0.5em;\n} */\n\n.no-border {\n    border: 0 !important;\n    box-shadow: none; /* You may want to include this as bootstrap applies these styles too */\n    padding-bottom: 0 !important;\n    text-overflow: ellipsis;\n}\n\n.inventory_list_container {\n    /* margin: 30px 30px 30px 30px; */\n    margin:0;\n    /* margin-top: 2em;*/\n    /* margin-bottom: 50px;  */\n    overflow-y: auto;\n    overflow-x: auto;\n    /* border: rgb(246, 6, 6) solid 1px; */\n    /* border: none; */\n    padding-top: 0px;\n    padding-bottom: 0px;\n    padding-left: 20px;\n    padding-right: 20px;\n    border: 1px solid gray;\n\n}\n\n\n.inventory_list_container_border {\n    /* border-bottom: 1px solid gray; */\n    height: 10px;\n    margin-left: 30px;\n    margin-right: 30px;\n    margin-top: 20px;\n    margin-bottom: 0;\n}\n\n\n.relative {\n    position: relative;\n}\n\n.absolute {\n    position: absolute;\n    width:100%;\n    height:100%;\n    top:0px;\n    left: 0px;\n    z-index: 2;\n    /* border: none; */\n    border-width: 1px;\n    border-style: solid;\n    /* gray;*/\n}\n\n.absolute:hover {\n    cursor:pointer;\n    /* background-color: rgba(63, 85, 92, 0.1); */\n    border-width: 5px;\n    border-style: double;\n    /* rgb(117, 116, 116); */\n}\n\n.non-admin {\n    border-color: gray;\n}\n\n.attestation-unknown {\n    border-color: gray;\n}\n\n.uncertified, .not-attested {\n    border-color: red;\n}\n\n.uncertified-text {\n    color:red;\n    font-weight: 600;\n}\n\n\n.init-certified {\n    border-color: orange;\n}\n\n.init-certified-text {\n    color: orange;\n    font-weight: 600;\n}\n\n.final-certified, .attested {\n    border-color: green;\n}\n\n.final-certified-text {\n    color: green;\n    font-weight: 600;\n}\n\n.attested-text {\n    color: green;\n    font-weight: 600;\n}\n\n.not-attested-text {\n    color: red;\n    font-weight: 600;\n}\n\n.cert-status {\n    width: 80% !important;\n}\n\n/* item-... - style to show certification status for admins */\n.item-uncertified, .item-not-attested {\n    background-color: red;\n    color:white;\n    font-weight: bold;\n}\n\n\n.item-uncertified-text, .item-not-attested-text {\n    color: red;\n    font-weight: 600;\n}\n/* .item-not-attested, .item-attested {\n    text-align: center;\n} */\n\n.item-init-certified {\n    background-color: orange;\n    color:white;\n    font-weight: bold;\n}\n\n.item-init-certified-text {\n    color: orange;\n    font-weight: 600;\n}\n\n.item-final-certified, .item-attested {\n    background-color: green;\n    color:white;\n    font-weight: bold;\n}\n\n.item-final-certified-text, .item-attested-text {\n    color: green;\n    font-weight: 600;\n}\n\n.readonly:read-only {\n    background-color: rgb(242, 242, 242);\n    color:rgb(100, 100, 100);\n}\n\n\n/* .required {\n    color: red;\n    font-weight: normal;\n}\n\n.annotation {\n    font-size: 0.8em;\n} */\n\n.invalid-feedback-override {\n    width: 75% !important;\n    white-space: wrap;\n    color: red;\n    font-size: .875em;\n}\n\n.form-field-info {\n    width: 75% !important;\n    white-space: wrap;\n    color: rgb(0, 93, 192);\n    font-size: .875em;\n    font-style: italic;\n}\n\n.textarea {\n    resize:both;\n}\n\n.inline-block {\n    display: inline-block;\n}\n\ninput[type='checkbox']:enabled {\n    border-color: rgb(39, 39, 39) !important;\n}\n\n.sup {\n    color: red;\n    font-size: 0.9em;\n}\n\n.ul-group-id {\n    color: red;\n    /* font-size: 0.8em; */\n    font-style: italic;\n    font-weight: 600;\n}\n\n.ul-no-bullets\n{\n    list-style-type: none;\n}\n\n.ul-no-bullets-li\n{\n    font-style: italic;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"field_header": `InventoryForm_field_header__Vh71Y`,
	"buffer": `InventoryForm_buffer__8kbBB`,
	"handle_overflow": `InventoryForm_handle_overflow__rWZcQ`,
	"err": `InventoryForm_err__0VnP3`,
	"switch": `InventoryForm_switch__OoBNG`,
	"inventory_container": `InventoryForm_inventory_container__E8BTS`,
	"alert-title": `InventoryForm_alert-title__chZHo`,
	"alert-title-black": `InventoryForm_alert-title-black__E0KgJ`,
	"confirmation-text": `InventoryForm_confirmation-text__uooMK`,
	"no-border": `InventoryForm_no-border__hhNmZ`,
	"inventory_list_container": `InventoryForm_inventory_list_container__bqCB1`,
	"inventory_list_container_border": `InventoryForm_inventory_list_container_border__eL0AI`,
	"relative": `InventoryForm_relative__9x5wv`,
	"absolute": `InventoryForm_absolute__mpRH1`,
	"non-admin": `InventoryForm_non-admin__S-0-n`,
	"attestation-unknown": `InventoryForm_attestation-unknown__Fyupc`,
	"uncertified": `InventoryForm_uncertified__mYB+Z`,
	"not-attested": `InventoryForm_not-attested__lUBMH`,
	"uncertified-text": `InventoryForm_uncertified-text__Ov9mi`,
	"init-certified": `InventoryForm_init-certified__-UHNO`,
	"init-certified-text": `InventoryForm_init-certified-text__91XWl`,
	"final-certified": `InventoryForm_final-certified__7mapw`,
	"attested": `InventoryForm_attested__l0S6r`,
	"final-certified-text": `InventoryForm_final-certified-text__w4oZj`,
	"attested-text": `InventoryForm_attested-text__Ls4A7`,
	"not-attested-text": `InventoryForm_not-attested-text__AIdyX`,
	"cert-status": `InventoryForm_cert-status__ZSL1-`,
	"item-uncertified": `InventoryForm_item-uncertified__d9VoX`,
	"item-not-attested": `InventoryForm_item-not-attested__2OEcY`,
	"item-uncertified-text": `InventoryForm_item-uncertified-text__2JEB9`,
	"item-not-attested-text": `InventoryForm_item-not-attested-text__jXDEc`,
	"item-init-certified": `InventoryForm_item-init-certified__BmL9t`,
	"item-init-certified-text": `InventoryForm_item-init-certified-text__4apA2`,
	"item-final-certified": `InventoryForm_item-final-certified__Njf3q`,
	"item-attested": `InventoryForm_item-attested__BZNvq`,
	"item-final-certified-text": `InventoryForm_item-final-certified-text__iO+9C`,
	"item-attested-text": `InventoryForm_item-attested-text__YcFqy`,
	"readonly": `InventoryForm_readonly__0bEao`,
	"invalid-feedback-override": `InventoryForm_invalid-feedback-override__QIHwX`,
	"form-field-info": `InventoryForm_form-field-info__oEJxY`,
	"textarea": `InventoryForm_textarea__S+-Rl`,
	"inline-block": `InventoryForm_inline-block__ldHlS`,
	"sup": `InventoryForm_sup__HbvCU`,
	"ul-group-id": `InventoryForm_ul-group-id__96HIV`,
	"ul-no-bullets": `InventoryForm_ul-no-bullets__Nqxg3`,
	"ul-no-bullets-li": `InventoryForm_ul-no-bullets-li__6GJNH`
};
export default ___CSS_LOADER_EXPORT___;
